export function BrandLockup({
  variant = "management",
  size = "default",
}: {
  variant?: "management" | "public";
  size?: "default" | "hero";
}) {
  return (
    <div className={`brand brand--${variant} brand--size-${size}`}>
      <div className="brand-logo-panel">
        <img
          className="brand-logo"
          src="/branding/fswl-logo.png"
          alt="FSWL"
          width={size === "hero" ? 128 : 96}
          height={size === "hero" ? 128 : 96}
        />
        {variant === "management" ? (
          <span className="brand-wordmark">
            FSWL <b>OPS</b>
          </span>
        ) : null}
      </div>
    </div>
  );
}

export function FswlPublicBrand({ size = "default" }: { size?: "default" | "hero" }) {
  return <BrandLockup variant="public" size={size} />;
}
